import React from "react";
import OverlayContainer from "@components/Overlay/OverlayContainer";
import "../../Other/BookDemo/contactsales.scss";

const Notification = ({ closeNotification }) => {
    const handleClose = () => {
        closeNotification();
    };
    return (
        <>
            <div className="notification-wrapper">
                <OverlayContainer>
                    <div className="inner-overlay book-demo ">
                        <div className="close-wrapper" onClick={handleClose}>
                            <div>
                                <i className="icon check" />
                            </div>
                        </div>
                        <div className="notification">
                            <div>
                                <img
                                    src={`${process.env.REACT_APP_SMIK_API_BASEURL}/icons/icon-complete-check.svg`}
                                    alt="check-complete"
                                />
                            </div>
                            <div className="status-message">
                                Your sales request was sent successfully!
                            </div>
                            <p>
                                We appreciate you for giving us the opportunity
                                to serve you, someone from our sales team will
                                be in touch with you in the next 48 hours!
                            </p>
                            <p>Thank You!</p>
                        </div>
                    </div>
                </OverlayContainer>
            </div>
        </>
    );
};

export default Notification;
